import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Container } from '@mui/material'
import ManagerDashboard from '../../components/StoreManagerPortal/Dashboard'
import InvoiceProcessing from '../../components/StoreManagerPortal/InvoiceProcessing'
import PayrollEntry from '../../components/StoreManagerPortal/PayrollEntry'
import VoiceAssistant from '../../components/StoreManagerPortal/VoiceAssistant'
import Layout from '../../components/Layout'

export default function ManagerPortal() {
  return (
    <Layout>
      <Container maxWidth="xl">
        <Routes>
          <Route path="/" element={<ManagerDashboard />} />
          <Route path="/invoices" element={<InvoiceProcessing />} />
          <Route path="/payroll" element={<PayrollEntry />} />
          <Route path="/assistant" element={<VoiceAssistant />} />
        </Routes>
      </Container>
    </Layout>
  )
}
